import { buildConnection, simplifyOrthogonalPoints } from '../../routing/CascadingRouting';
function pointsSignature(points, tolerance) {
    const r = (v) => Math.round(v / tolerance) * tolerance;
    return points.map((p) => `${r(p.x)},${r(p.y)}`).join(';');
}
function buildRenderPoints(buildOpts, locks) {
    const route = buildConnection({ ...buildOpts, locks });
    const full = [buildOpts.source, ...route.points, buildOpts.target];
    return simplifyOrthogonalPoints(full);
}
export function pruneRedundantLocks(locks, buildOpts, pruneOpts = {}) {
    var _a;
    const tolerance = (_a = pruneOpts.tolerance) !== null && _a !== void 0 ? _a : 0.5;
    if (!locks.length)
        return locks;
    const baseSig = pointsSignature(buildRenderPoints(buildOpts, locks), tolerance);
    let current = locks.slice();
    let changed = true;
    while (changed && current.length) {
        changed = false;
        for (let i = 0; i < current.length; i++) {
            const candidate = current.slice(0, i).concat(current.slice(i + 1));
            const sig = pointsSignature(buildRenderPoints(buildOpts, candidate), tolerance);
            if (sig === baseSig) {
                current = candidate;
                changed = true;
                break;
            }
        }
    }
    return current;
}
